import { render, staticRenderFns } from "./AlertErrors.vue?vue&type=template&id=1fc49a98"
import script from "./AlertErrors.vue?vue&type=script&lang=js"
export * from "./AlertErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports